import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';

export const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // Show tooltip after 3 seconds
    const timer = setTimeout(() => {
      setShowTooltip(true);
      // Hide tooltip after 5 seconds
      setTimeout(() => setShowTooltip(false), 5000);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const openWhatsApp = () => {
    const message = encodeURIComponent('Bonjour, je souhaite obtenir des informations sur vos services');
    window.open(`https://wa.me/33695701735?text=${message}`, '_blank');
  };

  return (
    <>
      {isVisible && (
        <div className="fixed bottom-6 right-6 z-50">
          {/* Tooltip */}
          {showTooltip && (
            <div className="absolute bottom-20 right-0 bg-white text-gray-900 px-4 py-3 rounded-lg shadow-xl max-w-xs animate-slideUp border-2 border-[#25D366]">
              <button 
                onClick={() => setShowTooltip(false)}
                className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
              >
                <X size={16} />
              </button>
              <p className="text-sm font-medium pr-4">
                Besoin d'aide ? Contactez-nous sur WhatsApp ! 💬
              </p>
            </div>
          )}

          {/* WhatsApp Button */}
          <button
            onClick={openWhatsApp}
            className="group relative w-16 h-16 bg-[#25D366] rounded-full shadow-2xl hover:scale-110 transition-all flex items-center justify-center animate-bounce hover:animate-none"
            aria-label="Contactez-nous sur WhatsApp"
          >
            <MessageCircle className="text-white" size={32} />
            
            {/* Pulse Animation */}
            <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-75"></span>
            
            {/* Notification Badge */}
            <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center text-white text-xs font-bold">
              1
            </span>
          </button>
        </div>
      )}
    </>
  );
};
